// add po image
export const SURGERY_USAGE_ATTACHMENT_UPLOAD =
    'SURGERY: USAGE_ATTACHMENT_UPLOAD';
export const SURGERY_USAGE_ATTACHMENT_UPLOAD_FAILURE =
    'SURGERY: USAGE_ATTACHMENT_UPLOAD_FAILURE';
export const SURGERY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE =
    'SURGERY: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE';
export const SURGERY_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE =
    'SURGERY: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE';
export const SURGERY_DELETE_ATTACHMENT_REQUEST =
    'SURGERY: DELETE_ATTACHMENT_REQUEST';
export const SURGERY_DELETE_ATTACHMENT_REQUEST_SUCCESS =
    'SURGERY: DELETE_ATTACHMENT_REQUEST_SUCCESS';
export const SURGERY_DELETE_ATTACHMENT_REQUEST_FAILURE =
    'SURGERY: DELETE_ATTACHMENT_REQUEST_FAILURE';
export const SURGERY_RESET_PO_ATTACHMENT = 'SURGERY: RESET_PO_ATTACHMENT';
export const SURGERY_GET_IMAGE_PO_PREVIEW = 'SURGERY: GET_IMAGE_PO_PREVIEW';
export const SURGERY_GET_IMAGE_PO_PREVIEW_SUCCESS =
    'SURGERY: GET_IMAGE_PO_PREVIEW_SUCCESS';
export const SURGERY_GET_IMAGE_PO_PREVIEW_FAILURE =
    'SURGERY: GET_IMAGE_PO_PREVIEW_FAILURE';
export const SET_SURGERY_NUMBER = 'SURGERY: SET_SURGERY_NUMBER';
export const RESOURCE_TYPE = 'ZOR';

export const CHECK_PRODUCT_BOM = 'SURGERY: CHECK_PRODUCT_BOM';
export const CHECK_PRODUCT_BOM_FAILURE = 'SURGERY: CHECK_PRODUCT_BOM_FAILURE';
export const CHECK_PRODUCT_BOM_SUCCESS = 'SURGERY: CHECK_PRODUCT_BOM_SUCCESS';
export const RESET_BOM_DATA = 'RESET_BOM_DATA';
export const DELETE_PRODUCT_BOM = 'DELETE_PRODUCT_BOM';
export const SET_ITEM_LIST_CLICKED = 'SET_ITEM_LIST_CLICKED';
export const SET_IMPLANT_AND_INSTRUMENT_PRODUCTS =
    'SET_IMPLANT_AND_INSTRUMENT_PRODUCTS';
export const GET_TRANSFER_RECIPIENT_METHODS =
    'SURGERY: GET_TRANSFER_RECIPIENT_METHODS';
export const GET_TRANSFER_RECIPIENT_METHODS_SUCCESS =
    'SURGERY: GET_TRANSFER_RECIPIENT_METHODS_SUCCESS';
export const GET_TRANSFER_RECIPIENT_METHODS_FAILURE =
    'SURGERY: GET_TRANSFER_RECIPIENT_METHODS_FAILURE';
export const CLEAR_TRANSFER_RECIPIENTS = 'SURGERY: CLEAR_TRANSFER_RECIPIENTS';
export const CLEAR_ERROR = 'SURGERY: CLEAR_ERROR';
export const CLEAR_TEMPLATE_PRODUCTS = 'SURGERY: CLEAR_TEMPLATE_PRODUCTS';
export const STORE_ADD_ITEM = 'STORE_ADD_ITEM';
export const STORE_ADD_ITEM_SUCEESS = 'STORE_ADD_ITEM_SUCEESS';
export const STORE_ADD_ITEM_FAILURE = 'STORE_ADD_ITEM_FAILURE';
export const CLEAR_ADD_ITEM = 'CLEAR_ADD_ITEM';
export const SET_PRODUCT_SEARCH_STATUS =
    'PRODUCT_SEARCH:SET_PRODUCT_SEARCH_STATUS';
